/* eslint-disable import/prefer-default-export */
export const MAX_WEIGHT = 5;
export const LOG_REDUX = true;
